import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';

function SelectableIconRadioList(props) {
  const selectedStyle = {
    borderRadius: '24px',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    webkitBoxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    mozBoxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    background: '#ffffff',
  };

  const baseStyle = {
    width: props.width ? props.width : '130px',
    height: props.height ? props.height : '130px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    '&:hover': selectedStyle,
  };

  const formLabelStyles = makeStyles(() => ({
    root: {
      ...baseStyle,
    },
  }));

  const selectedFormLabelStyles = makeStyles(() => ({
    root: {
      ...baseStyle,
      ...selectedStyle,
    },
  }));

  const radioButtonStyles = makeStyles(() => ({
    root: {
      '&:hover': {
        background: '#ffffff',
      },
    },
  }));

  const formLabelClasses = formLabelStyles();
  const selectedFormLabelClasses = selectedFormLabelStyles();
  const radioButtonClasses = radioButtonStyles();
  const selectedItem = props.items.find(i => i.checked);
  const [value, setValue] = useState(selectedItem ? selectedItem.value : '');

  const handleChange = event => {
    setValue(event.target.value);
    if (props.onRadioChange) {
      props.onRadioChange(event.target.value);
    }
  };

  return (
    <RadioGroup value={value} onChange={handleChange}>
      <Grid container>
        {props.items &&
          props.items.map((item, index) => (
            <Grid
              key={index}
              item
              xs={props.twoColumns ? 6 : 12}
              sm={props.twoColumns ? 6 : 12}
              align="center"
            >
              <FormControlLabel
                value={item.value}
                classes={
                  item.value === value
                    ? selectedFormLabelClasses
                    : formLabelClasses
                }
                control={
                  <Radio
                    classes={radioButtonClasses}
                    icon={item.icon}
                    checkedIcon={item.icon}
                  />
                }
                label={item.label}
              />
            </Grid>
          ))}
      </Grid>
    </RadioGroup>
  );
}

export default SelectableIconRadioList;
